import React from 'react';
import { useEffect } from 'react';
import { Layout, Flex } from 'app/components/base/Layout';
import BookHeader from 'app/components/book-trip/BookHeader';
import BookOnBehalfOf from 'app/components/book-trip/BookOnBehalfOf';
import YourTrip from 'app/components/book-trip/YourTrip/Desktop';
import PickupInformation from 'app/components/book-trip/PickupInformation/Desktop';
import PriceBreakdown from 'app/components/book-trip/PriceBreakdown';
import TripSummary from 'app/components/book-trip/TripSummary';
import PriceBreakdownLightbox from 'app/components/book-trip/PriceBreakdownLightbox';
import ContactInformation from 'app/components/book-trip/ContactInformation/Desktop';
import FinishBooking from 'app/components/book-trip/FinishBooking'
import Overlay from 'app/components/base/Overlay';
import ErrorLayout from '../commons/ErrorLayout';
import Assurances from 'app/components/common/Assurances';
import config from 'config';
import builder from '../builder';
import { BannerWrapper } from './elements';
import posthog from 'posthog-js';

import style from './style.css';


/**
 * Page component for displaying Mozio's Book Trip page.
 */
const BookTripPage = ({
  errorCode,
  errorMessage,
  errorPopup,
  errorProps,
  seachResultsLink,
  onSubmit,
  ...props
}) => {
  const { submitting } = props;

  useEffect(() => {
    posthog.capture('Checkout Page Viewed');
  }, []);

  if (errorCode && !errorPopup) {
    return (
      <ErrorLayout {...{ errorCode, errorProps, errorMessage, linkLocation: seachResultsLink }} />
    );
  }

  return (
    <Layout
      className={style.block}
      direction="column"
      size="noshrink"
      align="start stretch"
      nowrap
    >
      <BookHeader />
      <BannerWrapper>
        <Assurances />
      </BannerWrapper>
      <Layout
        className={style.layout}
        direction="row"
        align="center start"
      >
        <Flex className={style.content}>
          <div className={style.summary}>
            <TripSummary detailsComponent={PriceBreakdownLightbox} />
          </div>
          <BookOnBehalfOf />
          {config.REGULAR_YOUR_TRIP_SHOW && (
            <YourTrip />
          )}
          <ContactInformation {...props} />
          <PickupInformation />
          <FinishBooking onClick={onSubmit} loading={submitting} />
        </Flex>
        <Flex className={style.sidebar}>
          <PriceBreakdown />
        </Flex>
      </Layout>
      <Overlay show={submitting} transparent />
    </Layout>
  );
};

// TODO: move to Flow types
// BookTripPage.propTypes = {
//   onSubmit: PropTypes.func.isRequired,
//   submitting: PropTypes.bool,
//   errorCode: PropTypes.number,
//   errorMessage: PropTypes.string,
//   errorPopup: PropTypes.bool,
//   errorProps: PropTypes.object,
//   seachResultsLink: PropTypes.object
// };

export default builder(BookTripPage);
